const removeIdIfNew = item => (item.new ? { ...item, id: undefined } : item);

export function serializeFunnel(state, fields) {
  const form = new FormData();

  // Adding answer images as file part
  state.answers.items.filter(a => a.imagePartId && a.image).forEach(a => {
    form.append(a.imagePartId, a.image);
  });

  // Diff tree serialized as JSON for easier processing
  const diffAsJson = serializeAsJson(state, fields);
  form.append('diff', diffAsJson);

  // Appending funnel image
  form.append('image', fields.image);

  return form;
}

function serializeAsJson(state, fields) {
  const { name, image_id } = fields;

  const data = {
    name,
    image_id,
    questions: serializeQuestions(state),
    products: serializeProducts(state.products.items),
    scores: serializeScores(state.scores.items),
    exclusions: serializeExclusions(
      state.answers.items,
      state.exclusions.items
    ),
    advices: serializeAdvices(state.advices.items),
    removed_questions: state.history.questions.toArray(),
    removed_answers: state.history.answers.toArray(),
    removed_advices: state.history.advices.toArray(),
  };

  return JSON.stringify(data);
}

function serializeQuestions(state) {
  const answers = state.answers.items.map(a => serializeAnswer(a)).toArray();

  const answersForQuestion = question =>
    answers.filter(a => a.question.toString() === question.toString());

  return state.questions.items
    .map(q => {
      return {
        ...q,
        answers: answersForQuestion(q.id),
      };
    })
    .map(c => removeIdIfNew(c))
    .toArray();
}

function serializeAnswer(answer) {
  if (!answer.image) {
    return answer;
  }

  // Clearing image before serialization
  return {
    ...answer,
    image_part_id: answer.imagePartId,
    image_id: answer.image.id,
    imagePartId: undefined,
    image: undefined,
    thumbnail: undefined,
  };
}

function serializeProducts(products) {
  return products
    .map(p => {
      return {
        id: p.id,
        active: p.active || false,
      };
    })
    .toArray();
}

function serializeScores(scores) {
  return scores.toArray();
}

function serializeExclusions(answers, exclusions) {
  return exclusions
    .map(e =>
      e.answers
        .map((excluded, answer) => {
          const existing = answers.get(answer);
          const answerId = existing && !existing.new ? Number(answer) : answer;

          return {
            product: e.product,
            order: e.order,
            answer: answerId,
            excluded,
          };
        })
        .toArray()
    )
    .reduce((a, b) => a.concat(b), []);
}

function serializeAdvices(advices) {
  return advices.map(a => removeIdIfNew(a)).toArray();
}



// WEBPACK FOOTER //
// ./src/modules/funnel/utils/serialize.js